import { combineReducers } from 'redux';
import { bazaarVoiceRatingsReducer } from '@gcc/pip-components/dist/BazaarVoice';
import extendedReducer from './configurator';
import product from './product';
import productInfo from './productInfo';
import cart from './cart';
import skuMap from './skuMap';
import recommendations from './recommendations';
import storeSearch from './storeSearch';
import gallery from './gallery';
import config from './config';
import thdStoreInfo from './thdStoreInfo';
import pricing from './pricing';
import deliveryInfo from './deliveryInfo';
import canonicalUrl from './canonicalUrl';
import favorite from './favorite';
import choiceAndSkuAvailability from './choiceAndSkuAvailability';
import choiceInit from './choiceInit';
import earliestDeliveryInfo from './earliestDeliveryInfo';
import { hydrationReducer } from './hydrationReducer';
import { analyticsReducer } from './analytics';
import quickViewReducer from './quickViewReducer';
import orderSummaryReducer from './orderSummaryReducer';
import uploadImageReducer from './uploadImageReducer';
import { multipleLineIemPricing } from './multipleLinePricing';
import designReducer from './designReducer';
import liquidPixelReducer from './liquidPixelReducer';

const rootReducer = combineReducers({
  configurator: extendedReducer,
  product,
  productInfo,
  cart,
  skuMap,
  recommendations,
  storeSearch,
  gallery,
  config,
  thdStoreInfo,
  pricing,
  deliveryInfo,
  bazaarVoiceRatings: bazaarVoiceRatingsReducer,
  canonicalUrl,
  favorite,
  choiceAndSkuAvailability,
  choiceInit,
  earliestDeliveryInfo,
  hydration: hydrationReducer,
  analytics: analyticsReducer,
  quickView: quickViewReducer,
  orderSummary: orderSummaryReducer,
  multipleLineItem: multipleLineIemPricing,
  designContent: designReducer,
  uploadImages: uploadImageReducer,
  liquidPixel: liquidPixelReducer,
});

export default rootReducer;
